var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "featureGridComponent" }, [
    _c(
      "div",
      { staticClass: "featureGrid", style: _vm.featureGridStyles },
      _vm._l(_vm.getCellDefs(this.gridDef), function (cellDef) {
        return _c(
          "div",
          {
            class: _vm.featureGridCellClasses(cellDef),
            style: _vm.calcGridCellStyles(cellDef),
          },
          [
            _vm.showSlideNumbers
              ? _c("div", { staticClass: "numId" }, [
                  _vm._v(_vm._s(cellDef.imageNum + 1)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("cropzoomImg", {
              key: _vm.cellDefSlide(cellDef).title,
              ref: "imgs",
              refInFor: true,
              attrs: {
                src: _vm.cellDefSlide(cellDef).imageUrl,
                alt: _vm.cellDefSlide(cellDef).title,
                title: _vm.cellDefSlide(cellDef).title,
                "aspect-ratio": _vm.calcRealAspectRatio(cellDef),
                data: _vm.cellDefSlide(cellDef),
                "click-callback": _vm.handleClick,
              },
            }),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.hasMore
      ? _c("div", { ref: "viewmore", staticClass: "gridlayout-hasMoreUrl" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-primary-ghost",
              on: { click: _vm.viewMore },
            },
            [_vm._v("View More")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }